/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isEmpty } from 'lodash';

// Components
import MetaControl from 'shared/ui/components/form-components/MetaControl.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

// Constants
const SUPPORTED_KINDS = ['text', 'choice-list', 'text-multiline', 'boolean', 'choice', 'colour', 'number', 'html', 'locale', 'external'];
const MIN_NUM_FIELDS_FOR_SEARCH = 15;

const __vue_script__ = {
    name: 'BulkForm',

    components: { MetaControl, SearchBar, Toggler },

    props: {
        event: {
            type: Object,
            required: true
        },

        fpType: {
            type: String,
            required: true
        },

        items: {
            type: Array,
            default: () => []
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            eid: this.event._id,
            fields: {},
            form: {},
            metadata: [],
            searchTerm: '',
            settings: {}
        };
    },

    computed: {
        /** @returns {boolean} */
        showSearchBar() {
            return this.metadata.length > MIN_NUM_FIELDS_FOR_SEARCH;
        },

        /** @returns {object[]} */
        visibleFields() {
            if (!this.searchTerm.length) {
                return this.metadata;
            }

            const query = this.searchTerm.toLocaleLowerCase();
            const filter = c => {
                const search = [c.field, this.getLabel(c)].join(' ').toLocaleLowerCase();
                return search.includes(query);
            };

            return this.metadata.filter(filter);
        }
    },

    async created() {
        try {
            const metadata = await this.$services.metadata.getMetadataForTypeAsArray(this.eid, this.fpType, false, true);
            this.$utils.metadata.decorateLocaleFields(this.event, metadata, true);
            metadata.forEach(f => f.kind = f.kind ? f.kind : 'text');
            this.metadata = metadata.filter(field => field._bulk_edit !== false && SUPPORTED_KINDS.includes(field.kind));
            this.settings = await this.$services.settings.getSettings(this.eid);
        } catch (error) {
            console.error('[BulkForm] Could not load metadata for %s fp_type', this.fpType, error);
        }
    },

    methods: {
        /**
         * Gets the correct field descriptor label
         *
         * @param {object} item the field descriptor
         *
         * @returns {string} the field label
         */
        getLabel(item) {
            let label;
            if (item.label) {
                label = this.$te(item.label) ? this.$t(item.label) : item.label;
            } else if (this.$te(`general.forms.labels.${item.field}`)) {
                label = this.$t(`general.forms.labels.${item.field}`);
            }

            if (this.$utils.strings.isNotValidString(label)) {
                label = this.$utils.strings.humanize(item.field, true);
            }

            if (get(item, 'validations.required')) {
                label = `${label} *`;
            }

            return label;
        },

        /**
         * Builds the validations rules for the given file descriptor
         *
         * @param {Object} control the file descriptor to build the validators for
         *
         * @returns {String|null} a validators string as per vee-validate specifications
         */
        validators(control) {
            if (!this.fields[control.field]) {
                // If the toggler is off we don't have to validate
                return null;
            }

            if (control.kind === 'colour') {
                control.validations = control.validations || {};
                control.validations['hex_color'] = true;
            }

            const validators = Object.keys(control.validations || {}).filter(v => !['pattern'].includes(v)).join('|');

            return validators;
        },

        /**
         * Gets the default value for the given key
         *
         * @param {string} key the key to get the default value for
         *
         * @returns {any} the default value
         */
        getDefaultMetadataValue(key) {
            const metadata = this.metadata.find(m => m.field === key);
            return metadata ? metadata.default : null;
        },

        /**
         * Emits the form submission if the data is valid
         */
        async submit() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                return;
            }

            const options = {};
            for (const [key, val] of Object.entries(this.fields)) {
                if (val) {
                    options[key] = 'replace-all';
                }
            }

            const changes = {};
            for (const key of Object.keys(options)) {
                changes[key] = this.form.hasOwnProperty(key) ? this.form[key] : this.getDefaultMetadataValue(key);
            }

            const ids = this.items.map(i => i._id);

            if (!isEmpty(changes)) {
                console.info('[BulkForm] Form is valid, emitting data', changes, options, ids);
                this.$emit('submit', { changes, options, ids });
            } else {
                console.info('[BulkForm] No changes made');
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"bulk-form",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[(_vm.showSearchBar)?_c('search-bar',{attrs:{"show-no-result":false,"placeholder":_vm.$t('listings.editing.search_field')},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}):_vm._e(),_vm._l((_vm.visibleFields),function(control){return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(control.tooltip),expression:"control.tooltip"}],staticClass:"editing-group"},[_c('toggler',{attrs:{"name":((control.field) + "_toggler"),"on-label":_vm.getLabel(control),"off-label":_vm.getLabel(control),"disabled":_vm.disabled},model:{value:(_vm.fields[control.field]),callback:function ($$v) {_vm.$set(_vm.fields, control.field, $$v)},expression:"fields[control.field]"}}),(_vm.fields[control.field])?_c('validation-provider',{key:((control.order) + "-" + (control.field)),attrs:{"rules":_vm.validators(control),"name":control.field,"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('div',{staticClass:"feature-dependant"},[_c('meta-control',{attrs:{"control":control,"disabled":_vm.disabled,"errors":errors,"event":_vm.event,"settings":_vm.settings,"no-tip":true,"no-label":true},model:{value:(_vm.form[control.field]),callback:function ($$v) {_vm.$set(_vm.form, control.field, $$v)},expression:"form[control.field]"}})],1)]}}],null,true)}):_vm._e()],1)}),_c('button',{staticClass:"hidden"},[_vm._v(_vm._s(_vm.$t('general.confirm')))])],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BulkForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__